import { jsx as r, jsxs as d } from "react/jsx-runtime";
import * as m from "react";
import { ResponsiveContainer as u, PieChart as b, Pie as h, Cell as f, Tooltip as v, Legend as C } from "recharts";
import { cn as s } from "../../../lib/utils.js";
const a = {
  primary: "#134052",
  // lpr-teal
  accent: "#C5A880",
  // lpr-gold
  aqua: "#6BBFB0",
  // darker aqua for legibility in light mode
  neutral: "#D4CBBF",
  // lpr-neutral
  charcoal: "#2D2B28",
  // lpr-charcoal
  terracotta: "#D8A48F"
  // lpr-terracotta
}, x = [
  a.primary,
  a.accent,
  a.aqua,
  a.terracotta,
  a.neutral,
  a.charcoal
], y = ({ payload: e }) => r("div", { className: "flex flex-wrap justify-center gap-4 pt-4", children: e == null ? void 0 : e.map((t, l) => d("div", { className: "flex items-center gap-1.5", children: [r("div", { className: "h-3 w-3 rounded-sm shrink-0", style: { backgroundColor: t.color } }), r("span", { className: "text-xs text-[var(--text-primary)]", children: t.value })] }, l)) }), N = m.forwardRef(({ data: e, className: t, showLegend: l = !0, showTooltip: o = !0, innerRadius: c = 0, outerRadius: i = 80 }, n) => r("div", { ref: n, className: s("w-full h-[400px] md:h-[350px]", t), children: r(u, { width: "100%", height: "100%", children: d(b, { children: [r(h, { data: e, cx: "50%", cy: "45%", innerRadius: c, outerRadius: i, fill: a.primary, paddingAngle: 2, dataKey: "value", label: !0, children: e.map((p, g) => r(f, { fill: p.color || x[g % x.length] }, `cell-${g}`)) }), o && r(v, { contentStyle: {
  backgroundColor: "var(--bg-surface)",
  borderColor: "var(--border-color)",
  borderRadius: "8px",
  color: "var(--text-primary)"
}, itemStyle: { color: "var(--text-primary)" }, labelStyle: { color: "var(--text-secondary)" } }), l && r(C, { verticalAlign: "bottom", content: r(y, {}) })] }) }) }));
N.displayName = "PieChartComponent";
const k = m.forwardRef(({ label: e, value: t, change: l, changeType: o = "neutral", icon: c, className: i }, n) => {
  const p = {
    positive: "text-lpr-green",
    negative: "text-lpr-red",
    neutral: "text-[var(--text-secondary)]"
  };
  return d("div", { ref: n, className: s("card glass-card p-10 border-l-4 border-l-lpr-teal dark:border-l-lpr-gold shadow-luxury bg-[var(--bg-surface)] backdrop-blur-md relative overflow-hidden", i), children: [d("div", { className: "flex items-start justify-between relative z-10", children: [d("div", { className: "flex-1 space-y-4", children: [d("div", { children: [r("p", { className: "text-[10px] font-black text-[var(--text-secondary)] uppercase tracking-[0.2em] mb-1", children: e }), r("p", { className: "text-5xl font-black font-display tracking-tighter text-lpr-teal dark:text-lpr-gold leading-none", children: t })] }), l && d("div", { className: "flex items-center gap-2", children: [r("span", { className: s("text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-full bg-[var(--bg-muted)] border border-[var(--border-color)]", p[o]), children: l }), r("span", { className: "text-[10px] font-bold text-[var(--text-secondary)] uppercase tracking-widest", children: "Growth vs Target" })] })] }), c && r("div", { className: "ml-6 p-4 bg-lpr-teal/5 dark:bg-lpr-gold/10 text-lpr-teal dark:text-lpr-gold rounded-2xl shadow-subtle border border-lpr-teal/10 dark:border-lpr-gold/20", children: c })] }), r("div", { className: "absolute -bottom-10 -right-10 w-32 h-32 bg-lpr-teal/5 dark:bg-lpr-gold/10 rounded-full blur-3xl" })] });
});
k.displayName = "MetricCard";
const w = m.forwardRef(({ children: e, className: t, columns: l = 3 }, o) => r("div", { ref: o, className: s("grid gap-4", {
  2: "grid-cols-1 md:grid-cols-2",
  3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
}[l], t), children: e }));
w.displayName = "MetricsGrid";
export {
  a as COLORS,
  k as MetricCard,
  w as MetricsGrid,
  N as PieChartComponent
};
//# sourceMappingURL=Chart.js.map
